var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    d: "M44 16V32.38C44 39.66 39.66 44 32.38 44H15.62C8.34 44 4 39.66 4 32.38V16.02L44 16Z",
    fill: "url(#paint0_linear_150_32978)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9999 35.5C17.7799 35.5 17.5399 35.44 17.3399 35.34C15.7999 34.56 14.4799 33.4 13.5199 31.96C12.7199 30.76 12.7199 29.22 13.5199 28.02C14.4799 26.58 15.7999 25.42 17.3399 24.66C18.0799 24.28 18.9799 24.6 19.3599 25.34C19.7399 26.08 19.4399 26.98 18.6799 27.36C17.5999 27.9 16.6799 28.72 16.0199 29.72C15.8999 29.9 15.8999 30.14 16.0199 30.34C16.6799 31.34 17.5999 32.16 18.6799 32.7C19.4199 33.08 19.7199 33.98 19.3599 34.72C19.0799 35.2 18.5399 35.5 17.9999 35.5Z",
    fill: "url(#paint1_linear_150_32978)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4199 35.5C29.8599 35.5 29.3399 35.2 29.0799 34.68C28.6999 33.94 28.9999 33.04 29.7599 32.66C30.84 32.12 31.7599 31.3 32.4199 30.3C32.5399 30.12 32.5399 29.88 32.4199 29.68C31.7599 28.68 30.84 27.86 29.7599 27.32C29.0199 26.94 28.7199 26.04 29.0799 25.3C29.4599 24.56 30.36 24.26 31.1 24.62C32.64 25.4 33.9599 26.56 34.9199 28C35.7199 29.2 35.7199 30.74 34.9199 31.94C33.9599 33.38 32.64 34.54 31.1 35.3C30.86 35.44 30.6399 35.5 30.4199 35.5Z",
    fill: "url(#paint2_linear_150_32978)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44 15.62V16L4 16.02V15.62C4 8.34 8.34 4 15.62 4H32.38C39.66 4 44 8.34 44 15.62Z",
    fill: "url(#paint3_linear_150_32978)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_150_32978",
    x1: -21.935,
    y1: 49.0665,
    x2: 32.6863,
    y2: -21.9272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED573"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E5774D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#AE02A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1801A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_150_32978",
    x1: 12.9163,
    y1: 29.9996,
    x2: 19.528,
    y2: 29.9996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED573"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#E5774D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.432292,
    stopColor: "#AE02A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1801A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_150_32978",
    x1: 28.9119,
    y1: 29.984,
    x2: 35.5236,
    y2: 29.984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED573"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#E5774D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.432292,
    stopColor: "#AE02A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1801A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_150_32978",
    x1: -21.935,
    y1: 18.195,
    x2: -7.48663,
    y2: -25.5501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED573"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E5774D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#AE02A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1801A1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCode);
export default __webpack_public_path__ + "static/media/code.60205d74748535e7f1bdec84133a70d8.svg";
export { ForwardRef as ReactComponent };